import angular from 'angular';
import config from '../ConfigModule/ConfigModule';
import authService from '../Auth/CMSAuthService';

export default angular.module('cms.export.service', [config, authService]).factory('ExportService',
    function(CONFIG, CMSAuthService) {

        this.getUrl = (resourceName) => {

            let url = CONFIG.API_URL + '/' + resourceName + '/export';
            url += '?_format=json&start=0&limit=0&format=csv&Authorization=';
            url += CMSAuthService.getToken();
            return url;
        };

        return this;

}).name;


// WEBPACK FOOTER //
// ./src/cmsCore/Export/ExportService.js